import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import DownloadIcon from '@mui/icons-material/Download';
import { useTheme, useMediaQuery, Button, Divider, Stack } from '@mui/material';
import { useState, useEffect } from 'react';

interface CardInfo {
  title: string;
  fileLink: string;
}

export default function FlowAreaCard() {
  const [flowFiles, setFlowFiles] = useState<string[]>([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    fetch('/flow-models/index.json')
      .then(res => {
        if (!res.ok) throw new Error('Falha ao carregar index.json');
        return res.json() as Promise<string[]>;
      })
      .then(files => setFlowFiles(files))
      .catch(console.error);
  }, []);

  const cards: CardInfo[] = flowFiles.map(file => ({
    title: file
      .replace(/\.json$/, '')
      .split('-')
      .map(w => w[0].toUpperCase() + w.slice(1))
      .join(' '),
    fileLink: `/flow-models/${file}`
  }))
    .sort((a, b) =>
      a.title.localeCompare(b.title, 'pt', { sensitivity: 'base' })
    );

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: isMobile ? '0.5rem' : '1rem',
      }}
    >
      <Box sx={{ mb: 5 }}>
        <Typography gutterBottom variant={isMobile ? "h6" : "h4"} component="div">
          Modelos de Fluxo
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Os modelos de fluxo são arquivos JSON. Você pode baixar qualquer modelo, importá-lo direto no seu painel do Typebot para editar e iniciar rapidamente seu próprio atendente virtual.
        </Typography>
      </Box>
      <Stack
        divider={<Divider />}
        spacing={1}
      >
        {cards.map((card, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '0.5rem',
            }}
          >
            <Typography variant='subtitle1'>
              {card.title}
            </Typography>
            <Button
              variant="outlined"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
              }}
              onClick={() => {
                const link = document.createElement('a');
                link.href = card.fileLink;
                link.download = card.title;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            >
              <DownloadIcon />
              Baixar
            </Button>
          </Box>
        ))}
      </Stack>
    </Card>
  );
}